var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var slugify = require('../helpers/slugify');

// Job Area
module.exports = React.createClass({
		
	// Render
  	render: function(){
  		
   		return (
   			<div className="powered-by">
   				
   				<a target="_blank" href="http://searchsoftware.nl?ref=apply">
   					<img src="/assets/searchsoftware_logo.png" />
   				</a>
   				<div className="text">
   					<label>Powered by</label> <a target="_blank" href="http://searchsoftware.nl?ref=apply">Searchsoftware</a>
   				</div>
				<div className="clear"></div>
	  		</div>
	  	);
	}
});
